export default __webpack_public_path__ + "static/media/mynextLogo.2d12e160.png";